<template>
    <div class="booking-modal opacity-0 absolute pointer-events-none fixed w-full h-full top-0 left-0 flex flex-row items-center content-center" role="dialog" id="cancel-booking-modal">
        <div class="flex h-full modal-container modal-bg-dark mx-auto rounded shadow-lg z-50 self-center justify-center">

            <div class="modal-close absolute top-0 right-0 cursor-pointer flex flex-col items-center mt-4 mr-4 text-white text-sm">
                <span class="text-sm"></span>
            </div>

            <div class="modal-content text-left self-center bg-white shadow-lg rounded max-w-4xl">

                <div class="modal-header text-white flex justify-between bg-primary px-6 py-4 rounded-t">
                    <h4 class="modal-title">Avboka pass</h4>
                    <div>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                        <input type="hidden" id="cancel-booking-modal-id">
                    </div>
                </div>

                <div class="modal-body text-black mt-4 py-4 px-6">
                    <div class="h6 font-weight-bold"><span id="cancel-booking-modal-time"></span></div>
                    <div class="text-muted"><span id="cancel-booking-modal-location"></span></div>
                    <div class="text-muted"><span id="cancel-booking-modal-treatment"></span></div>
                    <div class="text-muted"><span id="cancel-booking-modal-therapist"></span></div>
                    <div class="preliminary-warning" id="cancel-booking-modal-prelim-warning">
                        <br>
                        <h4><i class="fa fa-warning"></i> Preliminär avbokning</h4>
                        <h5>Schemat har passerat gränsen för normal avbokning och avbokningen blir nu
                        en preliminär avbokning. Detta innebär att den schemalagda behandlingen debiteras som vanligt om inte tiden
                        bokas av en annan kund.</h5>
                    </div>
                    <div id="cancellation-limit-container">
                        <br>
                        <h5 class="my-2">Gräns för preliminär avbokning:</h5>
                        <div>Avboka passet senast <strong><span id="cancellation-limit-date-span"></span></strong> klockan
                            <strong><span id="cancellation-limit-time-span"></span></strong> för normal avbokning.<br>
                        <p class="text-sm my-1 italic text-gray-500">Vid senare avbokning så kommer den schemalagda behandlingen debiteras som vanligt om
                            inte tiden bokas av en annan kund.</p> </div>
                    </div>
                </div>
                <div class="modal-footer px-6 py-4 flex justify-between items-center">
                    <button type="button" class="border border-red-500 text-red-500 rounded p-2"
                            v-on:click="cancelBooking()"><i class="fa fa-times"></i> Avboka pass</button>
                    <button class="btn btn-dark text-gray-500"
                            data-dismiss="modal"><i class="fa fa-ban"></i> Avbryt</button>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    export default {
        name: "customer-dash-modal-cancel-booking",
        props: ['route_cancel'],
        methods: {
            cancelBooking: function () {
                let self = this;
                let thisModal = $("#cancel-booking-modal");

                let bookingIdInput = $("#cancel-booking-modal-id");
                let bookingId = bookingIdInput.val();

                axios.get(self.route_cancel + "/" + bookingId, {
                })
                .then(function (response) {
                    if (response.data.error) {
                        location.reload();
                    } else {
                        location.reload();
                    }

                })
                .catch(function (error) {
                    location.reload();
                });

                thisModal.modal('toggle');
            }
        }
    }
</script>

<style scoped>

</style>
